import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  interestsRequest: ['id', 'page', 'page_size', 'sort_field', 'sort_order', 'filter'],
  interestsSuccess: ['list'],
  interestsReset: null,

  interestRequest: ['id'],
  interestSuccess: ['focusRow'],
  interestReset: null,

  interestExampleRequest: ['language'],
  interestExampleSuccess: ['example'],

  interestsFetchingReset: null,

  interestFileRequest: ['id', 'page', 'page_size', 'sort_field', 'sort_order', 'filter'],
  interestFileSuccess: null,
})

export const InterestsTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  focusRow: null,

  example: null,
  exampleFetching: false,

  page: 1,
  page_size: 50,
  sort_field: null,
  sort_order: null,

  file: null,
  fileFetching: false,
})

/* ------------- Selectors ------------- */
export const AdvertisersSelectors = {
  getState: state => state.interests,
}

/* ------------- Reducers ------------- */

export const interestsRequest = (state, {id, page, page_size, sort_field, sort_order, filter}) => {
  return state.merge({fetching: true, page, page_size, sort_field, sort_order})
}

export const interestsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const interestExampleRequest = (state, {language}) => {
  return state.merge({exampleFetching: true})
}

export const interestExampleSuccess = (state, {example}) => {
  return state.merge({exampleFetching: false, example})
}

export const interestsReset = state => {
  return state.merge({
    list: null,
    fetching: false,

    focusRow: null,
  })
}

export const interestRequest = (state, {id}) => {
  return state.merge({fetching: true})
}

export const interestSuccess = (state, {focusRow}) => {
  return state.merge({fetching: false, focusRow})
}

export const interestReset = state => {
  return state.merge({
    fetching: false,
    focusRow: null,
  })
}

export const interestsFetchingReset = state => {
  return state.merge({
    fetching: false,
    exampleFetching: false,
    fileFetching: false,
  })
}

export const interestFileRequest = (state, {id, page, page_size, sort_field, sort_order, filter}) => {
  return state.merge({fileFetching: true})
}

export const interestFileSuccess = state => {
  return state.merge({fileFetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.INTERESTS_REQUEST]: interestsRequest,
  [Types.INTERESTS_SUCCESS]: interestsSuccess,
  [Types.INTERESTS_RESET]: interestsReset,

  [Types.INTEREST_REQUEST]: interestRequest,
  [Types.INTEREST_SUCCESS]: interestSuccess,
  [Types.INTEREST_RESET]: interestReset,

  [Types.INTEREST_EXAMPLE_REQUEST]: interestExampleRequest,
  [Types.INTEREST_EXAMPLE_SUCCESS]: interestExampleSuccess,

  [Types.INTEREST_FILE_REQUEST]: interestFileRequest,
  [Types.INTEREST_FILE_SUCCESS]: interestFileSuccess,

  [Types.INTERESTS_FETCHING_RESET]: interestsFetchingReset,
})
